import React from 'react';
import NextApp from 'next/app';
import { setAppElement } from 'react-modal';
import { SessionProvider as AuthProvider } from 'next-auth/react';
import { ExperimentProvider } from '../experiments/index';
import { APIProvider } from '../api';
import { GlobalStyle, OllieTheme } from '../theme';
import { Reporter, ReporterProvider } from '../reporter';
import { ToastProvider } from '../Toast/ToastProvider';
import { OfferProvider } from '../offer';
import { Gladly } from '../head';
import { ChatButton } from '../components';

class App extends NextApp {
  reporter = new Reporter();

  static async getInitialProps(arg) {
    // Opting out of ASO to get runtime env config on every page.
    // Yes, this isn't great, but injecting the env vars at buildtime
    // isn't possible in a docker world.
    // TODO(James) remove this... somehow.
    // Hey, if I had a plan, I wouldn't have wrote this in the first place.
    return super.getInitialProps(arg);
  }

  componentDidCatch(error, errorInfo) {
    this.reporter.error(error, { contexts: errorInfo });
  }

  componentDidMount() {
    setAppElement('#__next');
  }

  render() {
    const { Component, pageProps } = this.props;

    return (
      <AuthProvider session={pageProps.session}>
        <APIProvider reporter={this.reporter}>
          <ReporterProvider reporter={this.reporter}>
            <OllieTheme>
              <ToastProvider>
                <OfferProvider>
                  <ExperimentProvider>
                    <GlobalStyle />
                    <Component {...pageProps} />
                    <Gladly />
                    <ChatButton gladlySettings={pageProps.gladly} />
                  </ExperimentProvider>
                </OfferProvider>
              </ToastProvider>
            </OllieTheme>
          </ReporterProvider>
        </APIProvider>
      </AuthProvider>
    );
  }
}

export default App;
